import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const IMG_BASE = '/images/Feb18ServerSideRefactorImages/RedFlagAlert';

const RedFlagPigButcheringLearnMorePage = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full overflow-y-auto bg-white flex flex-col items-center">
      <div className="w-full max-w-[1920px]">

        {/* Back button */}
        <div className="px-12 pt-8 pb-4">
          <button
            onClick={() => navigate('/dashboard/red-flag-alert')}
            className="border border-gray-400 rounded px-8 py-2 text-base text-black hover:bg-gray-50 transition-colors"
          >
            Back
          </button>
        </div>

        {/* Title */}
        <div className="px-12 pb-4">
          <h1 className="text-4xl font-bold text-black">Pig Butchering - Cryptocurrency</h1>
        </div>

        {/* Hero image */}
        <div className="px-12 pb-4">
          <img
            src={`${IMG_BASE}/RedFlagPigButcheringLearnMore.jpeg`}
            alt="Pig Butchering - Cryptocurrency"
            className="w-full"
            style={{ height: '250px', objectFit: 'fill' }}
          />
        </div>

        {/* Separator */}
        <div className="px-12 pb-6">
          <hr className="border-gray-300" />
        </div>

        {/* What you need to know */}
        <div className="px-12 pb-8">
          <h2 className="text-2xl font-extrabold text-black mb-4">What you need to know</h2>

          <p className="text-black text-sm leading-relaxed mb-4">
            Scammers use the term &ldquo;Pig Butchering&rdquo; to describe the process of &ldquo;fattening&rdquo; up their victims with false attention before stealing their money.
          </p>

          <p className="text-black text-sm leading-relaxed mb-4">
            Have you ever gotten an unsolicited &ldquo;out of the blue&rdquo; text, email or a call. If so, you&rsquo;re being baited. It&rsquo;s the first step in starting a one-on-one conversation that enables them to carefully coach you through the abuse playbook stages in which leads to your emotional despair and financial exploitation.
          </p>

          <p className="text-black text-sm leading-relaxed mb-4">
            All Pig butchering scams start off friendly with the goal of building a common rapport. Their initial goal is to understand your wants and desires. A key part of the scam is presenting the illusion of being financially successful. This sets into motion their next move, turning the conversations towards investing. Once trust has been established, they&rsquo;ll propose an investment &ndash; crypto assets.
          </p>

          <p className="text-black text-sm leading-relaxed mb-4">
            Scammers don&rsquo;t directly ask for money. Rather, they discuss the huge profits and low risk. At this point a couple of things will start to happen. One, they&rsquo;ll show you a fake crypto trading platform clearly displaying large profits. Secondly, you might be shown an immediate small return on your first crypto investment &ndash; to set the hook. This gives the look of legitimacy and lowers your defenses. The truth is these platforms are fake; scammers have complete control.
          </p>

          <p className="text-black text-sm leading-relaxed mb-4">
            Perhaps you don&rsquo;t know about investing in crypto, don&rsquo;t worry, they&rsquo;ll help &ndash; they&rsquo;re helpful that way. You&rsquo;ll be encouraged to convert cash into crypto through a publicly known exchange, ATM, or digital wallet service and transfer it to a fraudulent platform.
          </p>

          <p className="text-black text-sm leading-relaxed mb-4">
            When the scammer senses the victim is getting wise to the scam or about to stop their investment, that triggers more aggressive action to secure one last payment. The victim is shown the losses and encouraged to make up the difference with additional funds. If the victim attempts to withdraw their investment, the scammer may demand that the victim pay purported taxes or early withdrawal fees. Once the victim is unable or unwilling to pay more into the scam, the scammer will abruptly cease all communications, taking the entire investment with them.
          </p>

          <p className="text-black text-sm leading-relaxed">
            In the end the victim is left financially and emotionally devastated.
          </p>
        </div>

      </div>
      <DashboardFooter />
    </div>
  );
};

export default RedFlagPigButcheringLearnMorePage;
